import { useQuery } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useGetWorksheet = (id) => {
  const formData = {};
  if (id) formData.id = id;

  return useQuery(
    ["getWorksheet", id],
    async () => {
      const { data } = await axiosPost("/api/cw/viewWorkSheet", formData);
      return data;
    },
    {
      refetchOnWindowFocus: false,
    }
  );
};

export default useGetWorksheet;
